<template>
  <div class="app-tab-config-center">
    <div class="page-toolbar">
      <div class="site-switcher">
        <span>站点：</span>
        <a-select
          v-model:value="activeSite"
          :options="siteOptions"
          :loading="siteLoading"
          :disabled="siteLoading || !siteOptions.length"
          placeholder="请选择站点"
        />
      </div>
      <a-button :loading="exportLoading" @click="handleExportConfig">
        <DownloadOutlined />
        导出配置
      </a-button>
    </div>

    <div class="page-content">
      <a-tabs v-model:activeKey="activeTab" class="main-tabs">
        <a-tab-pane key="layout" tab="Tab 栏配置">
          <TabLayoutPanel :site-id="activeSite" />
        </a-tab-pane>
        <a-tab-pane key="materials" tab="Tab 物料库">
          <TabMaterialLibrary :site-id="activeSite" />
        </a-tab-pane>
        <a-tab-pane key="history" tab="版本记录">
          <VersionHistory
            :site-id="activeSite"
            :active="activeTab === 'history'"
          />
        </a-tab-pane>
        <a-tab-pane key="experimentHistory" tab="实验记录">
          <VersionHistory
            :site-id="activeSite"
            :active="activeTab === 'experimentHistory'"
            experiment
          />
        </a-tab-pane>
      </a-tabs>
    </div>

    <ExportConfigModal
      v-model:visible="exportVisible"
      :records="publishedConfigs"
      :site-options="siteOptions"
    />
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { DownloadOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { common_querySiteInfo_get } from '@/server/modules/3426.js'
import { appTab_config_allPublished_get } from '@/server/modules/25824.js'
import ExportConfigModal from './components/ExportConfigModal.vue'
import TabLayoutPanel from './components/TabLayoutPanel.vue'
import TabMaterialLibrary from './components/TabMaterialLibrary.vue'
import VersionHistory from './components/VersionHistory.vue'

export default {
  name: 'AppTabConfigCenter',
  components: {
    DownloadOutlined,
    ExportConfigModal,
    TabLayoutPanel,
    TabMaterialLibrary,
    VersionHistory
  },
  setup() {
    const activeSite = ref()
    const activeTab = ref('layout')
    const siteLoading = ref(false)
    const siteOptions = ref([])
    const exportLoading = ref(false)
    const exportVisible = ref(false)
    const publishedConfigs = ref([])

    const loadSiteOptions = async () => {
      siteLoading.value = true
      try {
        const { success, data, retInfo } = await common_querySiteInfo_get()
        if (!success) {
          message.error(retInfo || '站点列表获取失败')
          return
        }

        const sites = Array.isArray(data?.['3']) ? data['3'] : []
        siteOptions.value = sites.map(item => ({
          label: item.name,
          value: item.id
        }))

        const defaultSite =
          siteOptions.value.find(item => Number(item.value) === 1) ||
          siteOptions.value[0]
        activeSite.value = defaultSite?.value
      } catch (error) {
        message.error(error?.message || '站点列表获取失败')
      } finally {
        siteLoading.value = false
      }
    }

    const handleExportConfig = async () => {
      if (exportLoading.value) return

      exportLoading.value = true
      try {
        const {
          success,
          data,
          retInfo
        } = await appTab_config_allPublished_get()
        if (!success) {
          message.error(retInfo || '已发布配置获取失败')
          return
        }

        publishedConfigs.value = Array.isArray(data) ? data : []
        exportVisible.value = true
      } catch (error) {
        message.error(error?.message || '已发布配置获取失败')
      } finally {
        exportLoading.value = false
      }
    }

    onMounted(loadSiteOptions)

    return {
      activeSite,
      activeTab,
      exportLoading,
      exportVisible,
      handleExportConfig,
      publishedConfigs,
      siteLoading,
      siteOptions
    }
  }
}
</script>

<style lang="scss" scoped>
.app-tab-config-center {
  display: flex;
  height: calc(100vh);
  overflow: hidden;
  background: #f0f2f5;
  flex-direction: column;
}

.page-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 0 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}

.site-switcher {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #595959;

  .ant-select {
    width: 120px;
  }
}

.page-content {
  flex: 1;
  min-height: 0;
  margin: 20px 20px 0;
  overflow: hidden;
  padding: 0 20px;
  background: #fff;
}

.main-tabs {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.main-tabs :deep(.ant-tabs-nav) {
  flex: 0 0 auto;
  margin-bottom: 20px;
}

.main-tabs :deep(.ant-tabs-content-holder) {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.main-tabs :deep(.ant-tabs-content) {
  height: 100%;
}

.main-tabs :deep(.ant-tabs-tabpane) {
  height: 100%;
  overflow: auto;
}
</style>
